'use client'

import Image from 'next/image'
import { updateCartItem, removeFromCart } from '@/lib/cart'
import type { CartItem as CartItemType } from '@/lib/types'

interface CartItemProps {
  item: CartItemType
  onUpdate: () => void
}

export default function CartItem({ item, onUpdate }: CartItemProps) {
  const imageUrl = item.imagePath
    ? `${process.env.NEXT_PUBLIC_SUPABASE_URL}/storage/v1/object/public/product-images/${item.imagePath}`
    : '/placeholder-product.png'

  const handleQuantityChange = (newQuantity: number) => {
    updateCartItem(item.productId, item.colorId, newQuantity)
    onUpdate()
  }

  const handleRemove = () => {
    removeFromCart(item.productId, item.colorId)
    onUpdate()
  }

  const subtotal = item.priceCents * item.quantity

  return (
    <div className="bg-white rounded-3xl shadow-soft p-5 flex flex-col sm:flex-row gap-4">
      <div className="w-24 h-24 relative bg-cloud rounded-2xl overflow-hidden flex-shrink-0">
        <Image src={imageUrl} alt={item.productName} fill className="object-cover" />
      </div>

      <div className="flex-1">
        <h3 className="font-semibold text-lg mb-1">{item.productName}</h3>
        <p className="text-sm text-gray-600 mb-2">Color: {item.colorName}</p>
        <p className="text-primary font-semibold">${(item.priceCents / 100).toFixed(2)} each</p>
      </div>

      <div className="flex flex-col items-end justify-between gap-3">
        <button
          onClick={handleRemove}
          className="text-red-500 hover:text-red-700 text-sm font-medium"
        >
          Remove
        </button>

        <div className="flex items-center space-x-2">
          <button
            onClick={() => handleQuantityChange(Math.max(1, item.quantity - 1))}
            className="w-9 h-9 rounded-full border border-gray-200 bg-cloud hover:bg-peach font-semibold"
          >
            -
          </button>
          <span className="w-8 text-center font-semibold">{item.quantity}</span>
          <button
            onClick={() => handleQuantityChange(item.quantity + 1)}
            className="w-9 h-9 rounded-full border border-gray-200 bg-cloud hover:bg-peach font-semibold"
          >
            +
          </button>
        </div>

        <p className="font-bold text-lg">${(subtotal / 100).toFixed(2)}</p>
      </div>
    </div>
  )
}
